/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_History_No_PlanInputs */

const cs_ebr_history_no_plan = /** @type {(inputs: Ebr_History_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plán tohoto běhu už není k dispozici.`)
};

const en_ebr_history_no_plan = /** @type {(inputs: Ebr_History_No_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan of this run is no longer available.`)
};

/**
* | output |
* | --- |
* | "The plan of this run is no longer available." |
*
* @param {Ebr_History_No_PlanInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_history_no_plan = /** @type {((inputs?: Ebr_History_No_PlanInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_History_No_PlanInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_history_no_plan(inputs)
	return cs_ebr_history_no_plan(inputs)
});